import React from "react";

export default function NoSelection() {
    return (
        <div className='display-container'>
            <h1>Nothing Selected</h1>
            <p>Press a button above to get started.</p>
        </div>
    )
}